var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CarouselImage } from '../carousel-image/CarouselImage';
import { View } from 'react-native';
export var ImageVideoSlide = props => {
  var type = props.type,
    videoProps = props.videoProps,
    style = props.style,
    rest = __rest(props, ["type", "videoProps", "style"]);
  switch (type) {
    case 'youtube-embedded-video':
      return _jsx(View, Object.assign({
        style: style
      }, {
        children: _jsx("iframe", {
          className: "iframe-container",
          id: "iframe",
          src: "https://www.youtube.com/embed/" + (videoProps === null || videoProps === void 0 ? void 0 : videoProps.videoId) + "?rel=0&showinfo=0&modestbranding=1&loop=1&playlist=" + (videoProps === null || videoProps === void 0 ? void 0 : videoProps.videoId) + "&autohide=1",
          width: '100%',
          height: '100%',
          loading: "eager"
        }, videoProps === null || videoProps === void 0 ? void 0 : videoProps.videoId)
      }));
    case 'image':
      return _jsx(CarouselImage, Object.assign({}, rest));
    default:
      return _jsx(_Fragment, {});
  }
};